import { useAtom } from 'jotai/index';
import { isTutorialActiveAtom, tutorialStageAtom, tutorialStepAtom } from '../atoms/tutorialsAtoms';
import sendRequest from '../helpers/sendRequest';
import Api from '../api';
import { profileAtom } from '../atoms/accountAtoms';

const useTutorials = () => {
  const [profile, setProfile] = useAtom(profileAtom);
  const [isTutorialActive, setIsTutorialActive] = useAtom(isTutorialActiveAtom);
  const [tutorialStep, setTutorialStep] = useAtom(tutorialStepAtom);
  const [tutorialStage, setTutorialStage] = useAtom(tutorialStageAtom);

  const changeTutorialStep = (payload) => {
    if (!isTutorialActive || tutorialStage !== 2) return false;

    if (tutorialStep === 1) { // selected configuration template
      if (payload?.id === 3) {
        setTutorialStep((prev) => prev + 1);
        return true;
      }
    }
    if (tutorialStep === 2) { // opened coating category
      if (payload?.id === 2) {
        setTutorialStep((prev) => prev + 1);
        return true;
      }
    }
    if (tutorialStep === 3) { // dragged cover layer into working space
      if (payload?.id === 7) {
        setTutorialStep((prev) => prev + 1);
        return true;
      }
    }
    if (tutorialStep === 4) { // clicked the glass with error
      if (payload?.id === 1) {
        setTutorialStep((prev) => prev + 1);
        return true;
      }
    }
    if (tutorialStep === 5) { // opened heat treatment select
      if (payload?.name === 'thermal_treatment') {
        setTutorialStep((prev) => prev + 1);
        return true;
      }
    }
    if (tutorialStep === 6) { // selected required heat treatment
      if (payload?.id === 25) {
        setTutorialStep((prev) => prev + 1);
        return true;
      }
    }
    if (tutorialStep === 7) { // saved glass with new params
      if (payload?.id === 1) {
        setTutorialStep((prev) => prev + 1);
        return true;
      }
    }
    if (tutorialStep === 8) { // after calculation
      setTutorialStep((prev) => prev + 1);
      return true;
    }
    if (tutorialStep === 9) { // on pdf download click
      setTutorialStep((prev) => prev + 1);
      return true;
    }
    if (tutorialStep === 10) { // on send email click
      setTutorialStep((prev) => prev + 1);
      return true;
    }
    if (tutorialStep === 11) { // on add to project click
      setTutorialStep((prev) => prev + 1);
      finishStage2();
      return true;
    }
  };

  const closeTutorials = () => {
    saveStage(0).then();
    setIsTutorialActive(false);
    setTutorialStep(1);
    setTutorialStage(1);
  };

  const finishStage1 = () => {
    saveStage(2).then();
    setIsTutorialActive(true);
    setTutorialStage(2);
    setTutorialStep(1);
  };

  const finishStage2 = () => {
    saveStage(3).then();
    setIsTutorialActive(false);
    setTutorialStage(3);
    setTutorialStep(1);
  };

  const saveStage = async (val) => {
    await sendRequest({
      request: Api.saveTutorialStage,
      payload: { stage: val },
      warnErrorText: 'while saving tutorial stage',
    });

    setProfile((prev) => ({ ...prev, stage: val }));
  };

  const handleTutorialStage = () => {
    const profileStage = profile?.stage ?? 1;

    setTutorialStep(1);
    setTutorialStage(profileStage);
    if (profileStage === 1 || profileStage === 2) {
      setIsTutorialActive(true);
    } else {
      setIsTutorialActive(false);
    }
  };

  return {
    changeTutorialStep,
    closeTutorials,
    finishStage1,
    finishStage2,
    saveStage,
    handleTutorialStage,

    tutorialStep,
    tutorialStage,
    isTutorialActive,
  };
};

export default useTutorials;
